/**
 * Haptic Feedback Utilities for iOS
 * Provides native iOS haptic feedback for better user experience
 */

import { isIOS } from './platformUtils';

/**
 * Trigger haptic feedback (iOS only)
 * @param type - Type of haptic feedback: 'light', 'medium', 'heavy', 'success', 'warning', 'error'
 */
export const triggerHaptic = async (type: 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' = 'light') => {
  if (!isIOS()) {
    return; // Only works on iOS
  }

  try {
    // Use Web Haptics API if available (iOS 13+)
    if ('vibrate' in navigator) {
      const patterns: { [key: string]: number | number[] } = {
        light: 10,
        medium: 20,
        heavy: 30,
        success: [10, 50, 10],
        warning: [20, 50, 20],
        error: [30, 50, 30, 50, 30]
      };

      const pattern = patterns[type] || 10;
      navigator.vibrate(pattern);
    }
  } catch (error) {
    console.warn('Haptic feedback not available:', error);
  }
};

/**
 * Trigger haptic on button press (iOS only)
 */
export const hapticButtonPress = () => {
  triggerHaptic('light');
};

/**
 * Trigger haptic on success action (iOS only)
 */
export const hapticSuccess = () => {
  triggerHaptic('success');
};

/**
 * Trigger haptic on error (iOS only)
 */
export const hapticError = () => {
  triggerHaptic('error');
};

